import {
  ColorIcon,
  colors,
  // HLine,
  HStack,
  VStack,
} from "goi_common";
import { useRouter } from "next/router";

import { useGetObituary } from "@/containers/BugoContainer/BugoCreateContainer/hooks/useGetObituary";

export const BugoSangjuMessageSection = ({
  readOnly,
}: {
  readOnly?: boolean;
}) => {
  const router = useRouter();
  const { obituaryKey } = router.query as { obituaryKey?: string };

  const { data: obituary } = useGetObituary(obituaryKey);

  const isUpdateMode = obituary?.custom_message && !readOnly;

  return (
    <VStack
      gap="8px"
      padding="40px 20px 0px"
      className="subtitle_18_sb"
      css={{
        background: colors.white,
      }}
      alignItems="center"
    >
      <HStack justifyContent="center" alignItems="center">
        <div>
          상주님 전하는 말씀{" "}
          {!readOnly && <span className="gray500">(선택)</span>}
        </div>
      </HStack>

      {obituary?.custom_message ? (
        <VStack
          gap="15px"
          padding="30px 0px"
          className="body_16_r gray800"
          alignItems="center"
          justifyContent="center"
          css={{
            textAlign: "center",
          }}
        >
          <div
            className="body_16_m gray900"
            css={{
              whiteSpace: "pre-wrap",
            }}
          >
            {obituary?.custom_message}
          </div>
          {isUpdateMode && (
            <HStack
              as="button"
              gap="4px"
              alignItems="center"
              className="body_14_m"
              css={{
                width: "fit-content",
                padding: "4px 12px",
                borderRadius: "20px",
                border: `1px solid ${colors.gray500}`,
              }}
              onClick={() => {
                obituaryKey
                  ? router.push(
                      `/bugo/update/sangjuMessage?obituaryKey=${obituaryKey}`
                    )
                  : router.push("/bugo/update/sangjuMessage/");
              }}
            >
              <ColorIcon name="icon-pencil" size="16px" color={colors.black} />
              {obituary?.custom_message ? "정보 수정하기" : "정보 입력하기"}
            </HStack>
          )}
        </VStack>
      ) : (
        <VStack
          gap="15px"
          padding="30px 0px"
          className="body_16_r gray800"
          alignItems="center"
          justifyContent="center"
          css={{
            textAlign: "center",
          }}
        >
          조문객 분들께 전달하고 싶은 메시지가
          <br />
          있으시다면 작성해주세요
          {!readOnly && (
            <HStack
              as="button"
              gap="4px"
              alignItems="center"
              className="body_14_m"
              css={{
                width: "fit-content",
                padding: "4px 12px",
                borderRadius: "20px",
                border: `1px solid ${colors.gray500}`,
              }}
              onClick={() => {
                obituaryKey
                  ? router.push(
                      `/bugo/update/sangjuMessage?obituaryKey=${obituaryKey}`
                    )
                  : router.push("/bugo/update/sangjuMessage/");
              }}
            >
              <ColorIcon name="icon-pencil" size="16px" color={colors.black} />
              {obituary?.custom_message ? "정보 수정하기" : "정보 입력하기"}
            </HStack>
          )}
        </VStack>
      )}
    </VStack>
  );
};
